import { Accordion, AccordionSummary, Typography, AccordionDetails } from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// DEFINITION
export default function Definition({ title, children }: DefinitionProps) {
    return (
        <Accordion aria-label={`definition of ${title}`}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>{title}</Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ p: 2, fontFamily: 'Public Sans', bgcolor: 'var(--darkbackground)' }}>
                {children}
            </AccordionDetails>
        </Accordion>
    )
}
